import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Lightweight anonymous page view tracker.
 * Fires once per route change. No PII collected.
 */
const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Skip admin and API paths
    if (path.startsWith("/admin") || path.startsWith("/api")) return;

    // Fire-and-forget — don't block rendering
    fetch(`${API_URL}/api/analytics/pageview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path }),
    }).catch(() => {});
  }, [location.pathname]);
};

export default usePageView;
